export const NAME = 'papers';